import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import devicesReducer from './devicesSlice';
import gatewaysReducer from './gatewaysSlice';
import settingsReducer from './settingsSlice';
import mapsReducer from './mapsSlice';
import userSettingsReducer from './userSettingsSlice';
import { uiReducer, mapReducer } from './uiSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        devices: devicesReducer,
        gateways: gatewaysReducer,
        settings: settingsReducer,
        maps: mapsReducer,
        userSettings: userSettingsReducer,
        ui: uiReducer,
        map: mapReducer, // Keep for backward compatibility
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
